import type { RouteRecordRaw } from 'vue-router'
import ShopLayout from '@/layouts/ShopLayout.vue'

const shopsRoutes: RouteRecordRaw[] = [
  {
    path: '/shops',
    component: ShopLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'butcher/sales',
        name: 'ButcherSales',
        component: () => import('@/views/shops/butcher/ButcherSalesView.vue'),
        meta: { title: 'Butcher Sales', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'butcher/products',
        name: 'ButcherProducts',
        component: () => import('@/views/shops/ProductsList.vue'),
        meta: { title: 'Butcher Products', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'butcher/products/register',
        name: 'ButcherRegisterProduct',
        component: () => import('@/components/ShopProductRegistration.vue'),
        meta: { title: 'Register Butcher Product', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'butcher/reports',
        name: 'ButcherReports',
        component: () => import('@/views/shops/butcher/ButcherReportsView.vue'),
        meta: { title: 'Butcher Reports', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'grocery/sales',
        name: 'GrocerySales',
        component: () => import('@/views/shops/grocery/GrocerySalesView.vue'),
        meta: { title: 'Grocery Sales', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'grocery/products',
        name: 'GroceryProducts',
        component: () => import('@/views/shops/ProductsList.vue'),
        meta: { title: 'Grocery Products', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'products',
        name: 'AllProducts',
        component: () => import('@/views/shops/ProductsList.vue'),
        meta: { title: 'All Products', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'grocery/products/register',
        name: 'GroceryRegisterProduct',
        component: () => import('@/components/ShopProductRegistration.vue'),
        meta: { title: 'Register Grocery Product', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'products/register',
        name: 'RegisterProduct',
        component: () => import('@/components/ShopProductRegistration.vue'),
        meta: { title: 'Register Product', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'grocery/reports',
        name: 'GroceryReports',
        component: () => import('@/views/shops/grocery/GroceryReportsView.vue'),
        meta: { title: 'Grocery Reports', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'local-harvest/sales',
        name: 'LocalHarvestSales',
        component: () => import('@/views/shops/localharvest/LocalHarvestSalesView.vue'),
        meta: { title: 'LocalHarvest Sales', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'local-harvest/reports',
        name: 'LocalHarvestReports',
        component: () => import('@/views/shops/localharvest/LocalHarvestReportsView.vue'),
        meta: { title: 'LocalHarvest Reports', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'outstanding-bills',
        name: 'OutstandingBills',
        component: () => import('@/views/shops/OutstandingBillsView.vue'),
        meta: { title: 'Outstanding Bills', requiresSupervisor: true, requiresAuth: true },
      },
      {
        path: 'customer-orders',
        name: 'CustomerOrders',
        component: () => import('@/views/shops/CustomerOrdersView.vue'),
        meta: { title: 'Customer Orders', requiresSupervisor: true, requiresAuth: true },
      },
    ],
  },
]

export default shopsRoutes
